import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["type"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import IconErrorAlert from '@lmig/lmds-react-icons/dist/icons/ErrorAlert';
import "./fieldGroupMessages.css";

/** An array of message type/text objects can be passed to the component. */

export var FieldGroupMessages = function FieldGroupMessages(_ref) {
  var className = _ref.className,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? [] : _ref$messages,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'status' : _ref$role;
  var MessageIcon = function MessageIcon(_ref2) {
    var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'error' : _ref2$type,
      props = _objectWithoutProperties(_ref2, _excluded);
    if (type === 'error') {
      return /*#__PURE__*/React.createElement(IconErrorAlert, _extends({
        size: "16",
        color: "negative"
      }, props));
    }
    throw Error('Could not find icon');
  };
  var getClassName = function getClassName() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'error';
    return classNames('lm-FieldGroupMessage', {
      'is-error': type === 'error'
    });
  };
  var filterMessages = function filterMessages(messagesToFilter) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';
    return messagesToFilter.filter(function (message) {
      return message.type === type;
    }).map(function (message) {
      return message.text;
    });
  };
  var filteredMessages = filterMessages(messages);
  var hasMessagesClass = filteredMessages.length ? 'has-messages' : '';
  var renderMessages = function renderMessages() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'error';
    if (filteredMessages.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement("ul", {
      className: getClassName(type)
    }, filteredMessages.map(function (message, index) {
      var key = "".concat(type, "-").concat(index);
      return /*#__PURE__*/React.createElement("li", {
        key: key
      }, /*#__PURE__*/React.createElement(MessageIcon, {
        type: type
      }), /*#__PURE__*/React.createElement("span", null, message));
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('lm-FieldGroupMessages', hasMessagesClass, className),
    role: role,
    "aria-live": role === 'alert' ? 'assertive' : 'polite'
  }, renderMessages('error'));
};
FieldGroupMessages.propTypes = {
  /** Add custom classes to this element: `<div class="lm-FieldGroupMessages">`. */className: _pt.string,
  /** Groups messages above the field group by type.
     * An array of message type/text objects can be passed to the component.
     * @default []
     */
  messages: _pt.arrayOf(_pt.shape({
    /** Provide a type for appropriate aria roles and styling. Currently, only "error" is supported.
       * @default 'error'
       */
    type: _pt.oneOf(['error']),
    /** Sets the text content of the message. */text: _pt.node
  })),
  /**
     * Sets the screen reader alert role for all messages.
     * Use `status` for polite (non-interruptive) experience or `alert` for an assertive experience.
     * @default 'status'
     */
  role: _pt.oneOf(['status', 'alert'])
};